import { ErrorModal } from "@/components/shared/modal/error-modal";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import * as React from "react";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { TableWorkerTypes } from "./components/WorkerTypesDataTable/TableWorkerTypes";
import { useWorkerTypesContext } from "./context/WorkerTypesContext";
import { getWorkerTypes } from "./repositories/WorkerTypesRepository";

export const WorkerTypes = () => {
	const { state, actions } = useWorkerTypesContext();
	const [isLoading, setIsLoading] = useState(true);

	const [showErrorModal, setShowErrorModal] = useState(false);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getWorkerTypesFromAPI = async () => {
		setIsLoading(true);
		try {
			const resp = await getWorkerTypes();

			if (resp.ok) {
				actions.setWorkerTypes(resp.data?.data);
				setIsLoading(false);
			}
		} catch (e: any) {
			setFetchDataError(e);
			setShowErrorModal(true);
		}
	};

	useEffect(() => {
		getWorkerTypesFromAPI();
	}, []);

	if (state.workerTypes) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: "20px" }}>
						<Paper
							elevation={1}
							style={{
								width: "100%",
								padding: "10px 0 50px",
								borderRadius: "0.75rem",
							}}
						>
							<TableWorkerTypes
								isLoading={isLoading}
								getWorkerTypesFromAPI={getWorkerTypesFromAPI}
							/>
						</Paper>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
				/>
			</>
		);
	}
	return <></>;
};
